import { MarketplaceState, marketplaceReducer } from '@spike/marketplace-action';
import { MasterDataState, masterDataReducer } from '@spike/masterdata-action';
import { NotificationsState, notificationsReducer } from '@spike/notifications-action';
import { RootAction } from 'actions/ActionTypes';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { LoginState } from 'reducers/login/LoginState';
import { loginReducer } from 'reducers/login/LoginReducer';
import { OrganizationState } from 'reducers/organizations/OrganizationState';
import { organizationsReducer } from 'reducers/organizations/OrganizationsReducer';
import { LocationState } from 'reducers/locations/LocationState';
import { locationsReducer } from 'reducers/locations/LocationsReducer';
import { OrganizationManagerState } from 'reducers/organizationManagers/OrganizationManagersState';
import { organizationManagersReducer } from 'reducers/organizationManagers/OrganizationManagersReducer';
import { UsersState } from 'reducers/users/UsersState';
import { usersReducer } from 'reducers/users/UsersReducer';
import { ContactsState } from 'reducers/contacts/ContactsState';
import { contactsReducer } from 'reducers/contacts/ContactsReducer';
import { SalesDashboardState } from 'reducers/salesDashboard/SalesDashboardState';
import { salesDashboardReducer } from 'reducers/salesDashboard/SalesDashboardReducer';
import { ApiKeysState } from 'reducers/apiKeys/ApiKeysState';
import { apiKeysReducer } from 'reducers/apiKeys/ApiKeysReducer';
import { EmailMarketingState } from 'reducers/emailMarketing/EmailMarketingState';
import { emailMarketingReducer } from 'reducers/emailMarketing/EmailMarketingReducer';
import { DataExportsState } from 'reducers/dataExports/DataExportsState';
import { dataExportsReducer } from 'reducers/dataExports/DataExportsReducer';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

// Create browser history
export const history = createBrowserHistory();

// Root State Interface (minimal for enterprise)
export interface RootState {
    readonly router: any;
    readonly login: LoginState;
    readonly masterData: MasterDataState;
    readonly marketplace: MarketplaceState;
    readonly notifications: NotificationsState;
    readonly organizations: OrganizationState;
    readonly locations: LocationState;
    readonly organizationManagers: OrganizationManagerState;
    readonly users: UsersState;
    readonly contacts: ContactsState;
    readonly salesDashboard: SalesDashboardState;
    readonly apiKeys: ApiKeysState;
    readonly emailMarketing: EmailMarketingState;
    readonly dataExports: DataExportsState;
}

// Root Reducer (minimal for enterprise)
const rootReducer = combineReducers<RootState, RootAction>({
    router: connectRouter(history),
    login: loginReducer,
    masterData: masterDataReducer,
    marketplace: marketplaceReducer,
    notifications: notificationsReducer,
    organizations: organizationsReducer,
    locations: locationsReducer,
    organizationManagers: organizationManagersReducer,
    users: usersReducer,
    contacts: contactsReducer,
    salesDashboard: salesDashboardReducer,
    apiKeys: apiKeysReducer,
    emailMarketing: emailMarketingReducer,
    dataExports: dataExportsReducer
});

// Middleware
const middleware = [thunk, routerMiddleware(history)];

// Create Store
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));

export { store };
export default store;
